import React from 'react';
import { Plus } from 'lucide-react';
import './AddWidgetCard.css';

interface AddWidgetCardProps {
  onAddWidget: () => void;
}

const AddWidgetCard: React.FC<AddWidgetCardProps> = ({ onAddWidget }) => {
  return (
    <div className="add-widget-card" onClick={onAddWidget}>
      <div className="add-widget-content">
        <div className="add-widget-icon">
          <Plus size={24} />
        </div>
        <p className="add-widget-text">Add Widget</p>
      </div>
    </div>
  );
};

export default AddWidgetCard;
